import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ReactSession } from "../../../../lib/secure_reactsession";
import { showToast } from "../../../../lib/helpers";
import { saveTreeTestResultQuestion } from "../../../../services/test_result";
import GlobalQuestion from "../../global-question";

export default function TreeTestFollowupQuestion({
    test,
    result,
    moveToNextTask,
    questionType,
    timeSpent,
    tree_test_task_question,
    task
}) {
    const location = useLocation();
    const [isActiveQuestion, setActiveQuestion] = useState(null);
    const [totalQuestion, setTotalQuestion] = useState(0);
    const [QuestionArrayList, setQuestionArrayList] = useState([]);
    const [questionLoading, setQuestionLoading] = useState(false);
    const [questionArray, setQuestionArray] = useState([]);
    const [questionTimeSpend, setQuestionTimeSpend] = useState(0);
    const [isNoneOfTheAboveSelected, setIsNoneOfTheAboveSelected] = useState(false);
    const isActiveQuestionId = useRef(null);
    const isSkipped = useRef(0);
    const isOptional = useRef(false);
    const skippedCount = useRef(0);
    const logicalySkipped = useRef(0);
    const [logicAdded, setLogicAdded] = useState(false);
    const [skippedCountState, setSkippedCountState] = useState(0);

    useEffect(() => {
        let Questions = [];

        if (questionType === "Survey") {
            if (test && tree_test_task_question.length) {
                setActiveQuestion(1);
                setTotalQuestion(test && tree_test_task_question.length);

                test &&
                    tree_test_task_question.forEach((items) => {
                        Questions.push({
                            data: items,
                            questionData: JSON.parse(items.questions),
                        });
                        if (JSON.parse(items.questions)["is_logic"] == 1) {
                            setLogicAdded(true);
                        }
                    });

                setQuestionArrayList(Questions);
                isOptional.current = Questions[0]['questionData']['is_optional'];
            } else {
                saveQuestionData([], true);
            }
        }

        window.scrollTo(0, 0);

        function tickTime() {
            setQuestionTimeSpend((prevSeconds) => prevSeconds + 1);
        }
        let timeData = setInterval(() => tickTime(), 1000);

        return () => clearInterval(timeData);
    }, []);

    const handleNextQuestion = (formData, endSurvey = false, jumpToQuestion = null) => {
        if (endSurvey) {
            saveQuestionData([...questionArray, formData], false);
            return;
        }

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        if (jumpToQuestion) {
            const nextQuestionCount = jumpToQuestion - isActiveQuestion;
            setActiveQuestion(isActiveQuestion + nextQuestionCount);
            logicalySkipped.current = 1;
        } else {
            setActiveQuestion(isActiveQuestion + 1);
        }

        setQuestionArray([...questionArray, formData]);
        setQuestionTimeSpend(0);
        isSkipped.current = 0;
        isActiveQuestionId.current = null;
        logicalySkipped.current = 0;

        // Check if this is the last question
        if (isActiveQuestion >= totalQuestion) {
            saveQuestionData([...questionArray, formData], false);
        }
    };

    const saveQuestionData = (formData, shouldNavigate) => {
        if (location.pathname.substr(1, 1) === "t") {
            let data = Object.assign({}, { questions: formData });
            data["test_id"] = result && result.test_id;
            data["result_id"] = result && result.id;
            data["question_type"] = questionType;
            data["task_id"] = task.id;
            data["guest_token"] = ReactSession.get("guest_token");
            data["time_spent"] = timeSpent;

            if (questionLoading) {
                return false;
            }

            if (!shouldNavigate) {
                setQuestionLoading(true);
            }

            saveTreeTestResultQuestion(data, ReactSession.get("token")).then(
                (response) => {
                    if (!shouldNavigate) {
                        setQuestionLoading(false);
                    }
                    if (response.success) {
                        moveToNextTask();
                    } else {
                        showToast(response.message, "error");
                    }
                }
            );
        } else {
            moveToNextTask();
        }
    };

    return (
        <div className="taking-test-page-wrap">
            <div className="container">
                {QuestionArrayList &&
                    QuestionArrayList.map((items, index) => {
                        return (
                            <div key={index}>
                                {isActiveQuestion === index + 1 && (
                                    <GlobalQuestion
                                        test={test}
                                        question={items}
                                        currentStep={isActiveQuestion}
                                        totalSteps={QuestionArrayList.length}
                                        onNext={handleNextQuestion}
                                        onSkip={() => {
                                            if (items.questionData.is_optional) {
                                                handleNextQuestion({
                                                    type: items.questionData.questionType,
                                                    question_id: items.data.id,
                                                    answer: "",
                                                    option_id: [],
                                                    is_skipped: 1,
                                                    question_time_spent: questionTimeSpend
                                                });
                                            }
                                        }}
                                        isOptional={items.questionData.is_optional}
                                        timeSpent={timeSpent}
                                        questionType={questionType}
                                        result={result}
                                        callback={moveToNextTask}
                                        methodology="tree"
                                        skippedCount={skippedCountState}
                                        onSkipCountChange={setSkippedCountState}
                                    />
                                )}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
}
